import { Card } from "../components/ui/card";
import { Badge } from "../components/ui/badge";
import { Trees, Compass, Users, Globe2 } from "lucide-react";
import { BRAND, LOGO_URL, STATS } from "../data/mock";

const values = [
  { icon: Trees, title: "Field-first", desc: "Every feature is tested in real conditions by real crews." },
  { icon: Compass, title: "Accuracy matters", desc: "Sub-metre GPS, calibrated measurements, audit-ready exports." },
  { icon: Users, title: "Built for crews", desc: "From a single contractor to enterprise field operations." },
  { icon: Globe2, title: "Works anywhere", desc: "Coverage gaps don’t stop work. Everything runs offline." }
];

export default function About() {
  return (
    <div className="max-w-7xl mx-auto px-5 lg:px-8 py-16">
      <div className="grid lg:grid-cols-2 gap-10 items-center">
        <div>
          <Badge className="bg-emerald-50 text-emerald-800 hover:bg-emerald-50 border-emerald-200 mb-3">About</Badge>
          <h1 className="text-4xl lg:text-5xl font-extrabold text-stone-900 tracking-tight">Laying out access — one map at a time.</h1>
          <p className="mt-4 text-stone-600 text-lg leading-relaxed">
            {BRAND.name} is built by a small team of foresters, surveyors and software engineers who got tired of fumbling with paper maps and disconnected GIS tools. We make the moment you step out of the truck the moment your software disappears — leaving only the data and decisions in front of you.
          </p>
        </div>
        <div className="relative">
          <div className="absolute -inset-6 bg-emerald-100/60 blur-2xl rounded-3xl" />
          <Card className="relative p-8 border-stone-200 bg-white text-center">
            <img src={LOGO_URL} alt={BRAND.name} className="h-32 w-32 mx-auto object-contain" />
            <div className="mt-2 font-extrabold text-2xl text-stone-900">{BRAND.name}</div>
            <div className="text-xs uppercase tracking-[0.22em] text-emerald-700 font-semibold mt-1">{BRAND.tagline}</div>
          </Card>
        </div>
      </div>

      <div className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-5">
        {STATS.map((s) => (
          <Card key={s.id} className="p-5 border-stone-200 bg-stone-50">
            <div className="text-3xl font-extrabold text-stone-900">{s.value}</div>
            <div className="text-sm text-stone-600 mt-0.5">{s.label}</div>
          </Card>
        ))}
      </div>

      <div className="mt-16">
        <h2 className="text-2xl lg:text-3xl font-bold text-stone-900">Our values</h2>
        <div className="mt-6 grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {values.map((v, i) => (
            <Card key={i} className="p-6 border-stone-200 bg-white">
              <div className="h-10 w-10 rounded-lg bg-emerald-50 text-emerald-700 flex items-center justify-center">
                <v.icon className="h-5 w-5" />
              </div>
              <div className="mt-4 font-semibold text-stone-900">{v.title}</div>
              <div className="text-sm text-stone-600 mt-1">{v.desc}</div>
            </Card>
          ))}
        </div>
      </div>
    </div>
  );
}
